const StatisticSchema = () => ({
  title: 'Estatísticas',
  fieldsets: [
    { id: 'default', title: 'Geral', fields: ['eyebrow', 'title', 'columns', 'size'] },
    { id: 'items', title: 'Indicadores', fields: ['items'] },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título da seção' },
    columns: {
      title: 'Colunas',
      choices: [
        ['2', '2'],
        ['3', '3'],
        ['4', '4'],
      ],
      default: '3',
    },
    size: {
      title: 'Tamanho do número',
      choices: [
        ['normal', 'Normal'],
        ['large', 'Grande'],
        ['huge', 'Enorme'],
      ],
      default: 'large',
    },
    items: {
      title: 'Indicadores',
      widget: 'object_list',
      schema: {
        title: 'Indicador',
        fieldsets: [{ id: 'default', title: 'Default', fields: ['value', 'label', 'info', 'href'] }],
        properties: {
          value: {
            title: 'Valor',
            description: 'Ex: 85%, 10 mil, R$ 1,2 bi',
          },
          label: { title: 'Rótulo' },
          info: {
            title: 'Informação adicional',
            description: 'Texto auxiliar exibido abaixo do rótulo (opcional).',
          },
          href: {
            title: 'Link (opcional)',
            description: 'URL onde o card leva ao clicar.',
          },
        },
        required: ['value'],
      },
    },
  },
  required: [],
});

export default StatisticSchema;
